import React, { useEffect, useState } from 'react';
import { SfcShellAppBarIcon } from '@waypoint/react-components';
import wmFetch from '../../../funcs/wmFetch';

const NotificationsBtn = () => {
	const [alertCount, setAlertCount] = useState(0);

	useEffect(() => {
		wmFetch('/v3/user/notifications', {})
			.then((res) => {
				const payload = res[0];
				const unreadInfo = payload['unreadNotifications'];
				if (unreadInfo) {
					setAlertCount(unreadInfo['unreadAlertCount']);
				}
			})
			.catch((err) => {
				console.error('Failed to fetch notifications:', err);
			});
	}, []);

	const handleClick = () => {
		if (alertCount > 0) {
			wmFetch('/v3/user/notification/read_all', {})
				.then(() => {
					window.location.href = '/notifications/active';
				})
				.catch((err) => {
					window.location.href = '/notifications/active';
				});
		} else {
			window.location.href = '/notifications/active';
		}
	};

	return (
		<SfcShellAppBarIcon
			data-attr-id="notifications-btn"
			slot="icons"
			icon="alert-notification"
			label="Notifications"
			alertCount={alertCount}
			onClick={handleClick}
		/>
	);
};

export default NotificationsBtn;


// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/WaypointShellNav/NotificationsBtn.js